<template>
<div>
  <v-tooltip
    bottom>
    <template
      v-slot:activator="{ on, attrs }">

      <v-chip
        v-bind="attrs"
        v-on="on"
        small
        color="primary"
        @click="onDialogButtonClick(item)"
      >
        車両編集
      </v-chip>

    </template>

    <!-- RAW形式で文字列展開 -->
    <span v-html="message"></span>

    <dd-haishahyo-himoduke-dialog
      :showDialog="showDialog"
      ref="haishahyoHimodukeDialog"
      @close="onDialogClosed"/>
  </v-tooltip>
</div>
</template>
<script>
const DdHaishahyoHimodukeDialog = () => import('@/components/DdHaishahyoHimodukeDialog.vue')

export default {
  name: 'DdHaishahyoHimodukeButton',
  components: {
    DdHaishahyoHimodukeDialog
  },
  props: {
    message: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    item: {
      type: Object
    }
  },
  data: () => ({
    innerValue: '',
    showDialog: false
  }),
  created () {
    this.innerValue = this.value
  },
  mounted () {
  },
  computed: {
    computedProps () {
      return {
        ...this.$props
        // readonly: this.readonly
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    isHelpDisplay () {
      return this.readonly === false
    }
  },
  methods: {
    onDialogButtonClick: function (e) {
      this.$refs.haishahyoHimodukeDialog.fetchData(this.item)
        .then(() => {
          this.showDialog = true
          console.log('dialog opend', e)
        })
    },
    onDialogClosed: function (e) {
      console.log('dialog closed', e, this.showDialog)
      this.showDialog = false
      /**
       * dialog選択値inputイベント
       * @event input
       * @type {Event}
       * this.$emit('input', this.innerValue)
       */
    }
  }
}
</script>
<style scoped>

</style>
